import { render } from "./TableForms.vue?vue&type=template&id=dac0d35e&scoped=true"
import script from "./TableForms.vue?vue&type=script&lang=js"
export * from "./TableForms.vue?vue&type=script&lang=js"

import "./TableForms.vue?vue&type=style&index=0&id=dac0d35e&lang=sass&scoped=true"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dac0d35e"]])

export default __exports__